export default "__VITE_ASSET__DYcigYTO__"